<template>
  <div class="contact" :key="`contact_` + $store.state.calculatorData.contactToggleState">
    <div class="container">
      <div class="row">

        <div class="col-md-12">
          <h2>{{ $t(`contact.title`)}}</h2>
          <p v-html="$t(`contact.infoText`)"></p>
        </div>

        <div class=" col-md-12 align-self-center highlight-box">
          <form @submit.prevent="submit">

            <div class="row">
              <input type="hidden" value="tiny-url" />
              <div class="input-field col-md-12">
                <div>
                  <p v-if="this.$store.state.calculatorData.tinyLink">
                    <a :href="shortenerLink()"> {{ shortenerLink() }} </a>
                  </p>
                  <a class="button" v-else @click="clickCreateTinyLink()">{{ $t(`merchandiserView.generateLink`)}}</a>
                </div>
              </div>
              <div class="input-field col-md-6">
                <label :for="type + `_firstName`" :class="{error: $v.firstName.$error}">{{$t('contact.content.firstName')}} *</label>
                <input type="text" name="firstName" :id="type + `_firstName`" v-model.trim="$v.firstName.$model" v-on:blur="lostFocus('firstName')" />
              </div>

              <div class="input-field col-md-6">
                <label f:or="type + `_name`" :class="{error: $v.name.$error}" >{{$t('contact.content.name')}} *</label>
                <input type="text" name="name" :id="type + `_name`" v-model.trim="$v.name.$model" v-on:blur="lostFocus('name')" />
              </div>

              <div class="input-field col-md-6">
                <label :for="type + `_businessName`" :class="{error: $v.businessName.$error}" >{{$t('contact.content.businessName')}} *</label>
                <input type="text" name="businessName" :id="type + `_businessName`" v-model.trim="$v.businessName.$model" v-on:blur="lostFocus('businessName')" />
              </div>

              <div class="input-field col-md-6">
                <label :for="type + `_streetAndNumber`">{{$t('contact.content.streetAndNumber')}}</label>
                <input type="text" name="streetAndNumber" :id="type + `_streetAndNumber`" v-model="streetAndNumber" v-on:blur="lostFocus('streetAndNumber')" />
              </div>

              <div class="input-field col-md-6">
                <label :for="type + `_postcode`">{{$t('contact.content.postcode')}}</label>
                <input type="text" name="postcode" :id="type + `_postcode`" v-model="postcode" v-on:blur="lostFocus('postcode')" />
              </div>

              <div class="input-field col-md-6">
                <label :for="type + `_city`">{{$t('contact.content.city')}}</label>
                <input type="text" name="city" :id="type + `_city`" v-model="city" v-on:blur="lostFocus('city')" />
              </div>

              <div class="input-field col-md-6">
                <label :for="type + `_type + _phone`">{{$t('contact.content.phone')}}</label>
                <input type="text" name="phone" :id="type + `_type + _phone`" v-model="phone" v-on:blur="lostFocus('phone')" />
              </div>

              <div class="input-field col-md-6">
                <label :for="type + `_email`" :class="{error: $v.email.$error}" >{{$t('contact.content.email')}} *</label>
                <input type="text" name="email" :id="type + `_email`" v-model.trim="$v.email.$model" v-on:blur="lostFocus('email')" />
              </div>

              <div class="input-field col-md-12">
                <label :for="type + `_message`">{{$t('contact.content.message')}}</label>
                <textarea rows="4" cols="30" :id="type + `_message`" name="message" v-model="message" v-on:blur="lostFocus('message')">
                </textarea>
              </div>
              <div class="col-md-8">
                <span class="font-size-small" :class="{error: $v.$anyError}"> * {{$t('contact.content.requiredFields')}}  </span>
              </div>
              <div class="col-md-4 align-self-end">
                <button type="submit" :disabled="submitStatus === 'PENDING'">{{$t('contact.content.send')}}</button>
                <p class="typo__p" v-if="submitStatus === 'OK'">{{$t('contact.content.contactSubmitted')}}</p>
              </div>
              <div class="col-md-12 ">
                <p class="typo__p" v-if="submitStatus === 'ServerError'">Beim versenden der E-Mail ist ein Fehler aufgetreten.<br />
                  <a :href="`mailto:infoservice@sto.com?subject=Berechnung%20Jalousiekasten&body=&body=`+ $t('contact.content.firstName')  + `: `+ firstName + `%0A` + $t('contact.content.name')  + `: ` + name + `%0A` + $t('contact.content.businessName')  + `: ` + businessName + `%0A` + $t('contact.content.streetAndNumber')  + `: ` + streetAndNumber + `%0A` + $t('contact.content.postcode')  + `: ` + postcode + `%0A` + streetAndNumber + `%0A` + $t('contact.content.city')  + `: ` + city + `%0A` + streetAndNumber + `%0A` + $t('contact.content.phone')  + `: ` + phone + `%0A` + $t('contact.content.email')  + `: ` + email + `%0A` + $t('contact.content.message')  + `: ` + message">Hier können Sie alternativ von Ihrem E-Mail Programm Kontakt aufnehmen.</a>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <StepNavi thisPage="contact" />
  </div>
</template>

<script>
import StepNavi from './StepNavi.vue'
import { required, email } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'Contact',
  components: {
    StepNavi
  },
  props: {
    type: String
  },
  computed: {
    ...mapGetters([
      'tinyLink',
      'base64Link'
    ])
  },
  data () {
    return {
      firstName: '',
      name: '',
      businessName: '',
      streetAndNumber: '',
      postcode: '',
      city: '',
      phone: '',
      email: '',
      message: '',
      submitStatus: null
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        const invalidFields = Object.keys(this.$v.$params).filter(fieldName => this.$v[fieldName].$invalid)
        invalidFields.forEach(element => { this.tracking('Fehlerhafte Eingabe', element) })
      } else {
        this.postNow()
        this.submitStatus = 'PENDING'
      }
    },
    postNow () {
      this.registerUserInput()
      // const translations = {
      //   firstNameTranslation: this.$t('contact.content.firstName'),
      //   nameTranslation: this.$t('contact.content.name'),
      //   businessNameTranslation: this.$t('contact.content.businessName'),
      //   streetAndNumberTranslation: this.$t('contact.content.streetAndNumber'),
      //   postcodeTranslation: this.$t('contact.content.postcode'),
      //   cityTranslation: this.$t('contact.content.city'),
      //   phoneTranslation: this.$t('contact.content.phone'),
      //   emailTranslation: this.$t('contact.content.email'),
      //   messageTranslation: this.$t('contact.content.message'),
      //   tinyLinkTranslation: this.$t('contact.content.tinyLink')
      // }

      // TODO: Find a way to make this post Data translateable
      let self = this
      const postData = {
        mail: {
          'Vorname': self.firstName,
          'Nachname': self.name,
          'Firma / Unternehmer': self.businessName,
          'Strasse / Hausnummer': self.streetAndNumber,
          'PLZ': self.postcode,
          'Ort': self.city,
          'Telefon': self.phone,
          'E-Mail': self.email,
          'Ihre Nachricht': self.message,
          'Link': self.shortenerLink()
        }
      }

      this.axios.post(
        process.env.VUE_APP_LOCAL_API_URL + '/mail',
        postData
      ).then(r => {
        // this.submitStatus = 'ServerError'
        if (r.status === 200) {
          this.submitStatus = 'OK'
          this.tracking('Kontaktformular absenden', 'absenden erfolgreich')
        } else if (r.status === 400) {
          this.submitStatus = 'ServerError'
          this.tracking('Kontaktformular absenden', 'ServerFehler')
        }
      }).catch(error => {
        console.log(error.response)
        this.tracking('Kontaktformular absenden', 'ServerFehler Keine Verbindung')
      })
    },
    shortenerLink: function () {
      return process.env.VUE_APP_LOCAL_API_URL.replace(/^\/\//, `${location.protocol}//`) + '/shortener/' + this.tinyLink
    },
    clickCreateTinyLink: function (event) {
      this.createTinyLink(event)
      this.registerUserInput()
    },
    createTinyLink: function (event) {
      let postData = { original_string: this.base64Link }
      this.axios.post(
        process.env.VUE_APP_LOCAL_API_URL + '/shorten',
        postData
      ).then(r => {
        if (r.status === 200) {
          this.$store.commit('updateTinyLink', r.data.answer)
          this.tinyStatus = 'OK'
          this.tracking('Button', 'Link erstellen Erfolgreich')
        } else if (r.status === 400) {
          this.tinyStatus = 'ERORR'
          this.tracking('Button', 'Link erstellen Fehler Erstellung')
        }
      }).catch(error => {
        console.log(error.response)
        if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
          this.tracking('Button', 'Link erstellen Server Fehler')
        }
      })
    },
    lostFocus: function (inputField) {
      // v-on:click="registerUserInput()" v-on:keyup="registerUserInput()
      this.registerUserInput()
      this.tracking('Input', inputField)
    },
    registerUserInput: function () {
      // this line needs to track only User Input
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp) {
        rootApp.userDidAction = true
      }
    },
    tracking: function (eventAction, eventLabel) {
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (!rootApp || typeof rootApp.globalGTMFkt !== 'function') return
      
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = 'Kontaktformular'
      let gtmEventAction = eventAction
      let gtmEventLabel = eventLabel
      let virtualPageURL = '/kontakt'
      let virtualPageTitle = 'Kontakt'
      rootApp.globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
    }
  },
  validations: {
    firstName: { required },
    name: { required },
    businessName: { required },
    email: { required, email }
  },
  mounted: function () {
    // console.log('--- Contact rendert ---')
    this.createTinyLink()
  }
}
</script>

<style scoped>

</style>
